// Adapted from https://github.com/michaelrhodes/get-image-data because
// including that library breaks react server-side rendering. Probably
// because of the old syntax.

const get = (src, cb) => {
  const img = new Image();
  img.crossOrigin = "anonymous";
  img.src = src;
  img.onerror = cb;
  img.onload = () => {
    cb(null, data(img));
  };
};
const data = img => {
  const canvas = document.createElement("canvas");
  const ctx = canvas.getContext("2d");
  canvas.width = img.width;
  canvas.height = img.height;
  ctx.drawImage(img, 0, 0);
  return ctx.getImageData(0, 0, img.width, img.height);
};
var get$1 = get;

export { get$1 as default };
